import * as React from 'react';
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {ICustomerPortalService, Policy, Quote, Subscription, Types} from "@falcon/services";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {YourQuotesPanel} from "./YourQuotesPanel";
import {authorize, Overlay} from "@athena-portal/components";

interface IState {
    quotes?: Quote[];
    policies?: Policy[];
    subscription? : Subscription;
}

@authorize
export class QuotesPage extends React.Component<{}, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: Readonly<{}>) {
        super(props);
        this.state = {}
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Your quote(s)");
        this.customerPortalService.getQuotes().subscribe((quotes: Quote[]) => this.setState({quotes}));
        this.customerPortalService.getUserPoliciesWithLatestVersions().subscribe((policies: Policy[]) => {
            this.setState({policies});

            if (policies && policies.length > 0) {
                this.customerPortalService.getSubscription().subscribe((subscription: Subscription) => {
                    this.setState({subscription});
                });
            }
        });
    }

    public render() {
        const {policies, quotes, subscription} = this.state;

        if (quotes && policies) {
            return (
                <React.Fragment>
                    <FalconHeader/>
                    <YourQuotesPanel
                        quotes={quotes}
                        isActivePoliciesPresent={policies.length > 0}
                        policies={policies}
                        subscription={subscription}/>
                    <FalconFooter/>
                </React.Fragment>
            )
        } else {
            return <Overlay show={true}/>
        }
    }
}
